import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useMapContext } from '../map-context';
export function useMapControls() {
  const $ = _c(40);
  const {
    map
  } = useMapContext();
  let t0;
  if ($[0] !== map) {
    t0 = () => {
      if (map) {
        map.zoomIn();
      }
    };
    $[0] = map;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const zoomIn = t0;
  let t1;
  if ($[2] !== map) {
    t1 = () => {
      if (map) {
        map.zoomOut();
      }
    };
    $[2] = map;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const zoomOut = t1;
  let t2;
  if ($[4] !== map) {
    t2 = zoom => {
      if (map) {
        map.zoomTo(zoom);
      }
    };
    $[4] = map;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const zoomTo = t2;
  let t3;
  if ($[6] !== map) {
    t3 = (lngLat, options) => {
      if (map) {
        map.panTo(lngLat, options);
      }
    };
    $[6] = map;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const panTo = t3;
  let t4;
  if ($[8] !== map) {
    t4 = options_0 => {
      if (map) {
        map.flyTo(options_0);
      }
    };
    $[8] = map;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const flyTo = t4;
  let t5;
  if ($[10] !== map) {
    t5 = () => {
      if (map) {
        map.stop();
      }
    };
    $[10] = map;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const stop = t5;
  let t6;
  if ($[12] !== map) {
    t6 = (bounds, options_1) => {
      if (map) {
        map.fitBounds(bounds, options_1);
      }
    };
    $[12] = map;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const fitBounds = t6;
  let t7;
  if ($[14] !== map) {
    t7 = () => map?.getCenter();
    $[14] = map;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const getCenter = t7;
  let t8;
  if ($[16] !== map) {
    t8 = () => map?.getZoom();
    $[16] = map;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const getZoom = t8;
  let t9;
  if ($[18] !== map) {
    t9 = () => map?.getBounds();
    $[18] = map;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const getBounds = t9;
  let t10;
  if ($[20] !== map) {
    t10 = () => map?.getBearing() ?? 0;
    $[20] = map;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const getBearing = t10;
  let t11;
  if ($[22] !== map) {
    t11 = () => map?.getPitch() ?? 0;
    $[22] = map;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const getPitch = t11;
  let t12;
  if ($[24] !== map) {
    t12 = () => {
      if (map) {
        map.easeTo({
          bearing: 0,
          pitch: 0,
          duration: 300
        });
      }
    };
    $[24] = map;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const resetOrientation = t12;
  let t13;
  if ($[26] !== fitBounds || $[27] !== flyTo || $[28] !== getBearing || $[29] !== getBounds || $[30] !== getCenter || $[31] !== getPitch || $[32] !== getZoom || $[33] !== panTo || $[34] !== resetOrientation || $[35] !== stop || $[36] !== zoomIn || $[37] !== zoomOut || $[38] !== zoomTo) {
    t13 = {
      zoomIn,
      zoomOut,
      zoomTo,
      panTo,
      flyTo,
      fitBounds,
      stop,
      getCenter,
      getZoom,
      getBounds,
      getBearing,
      getPitch,
      resetOrientation
    };
    $[26] = fitBounds;
    $[27] = flyTo;
    $[28] = getBearing;
    $[29] = getBounds;
    $[30] = getCenter;
    $[31] = getPitch;
    $[32] = getZoom;
    $[33] = panTo;
    $[34] = resetOrientation;
    $[35] = stop;
    $[36] = zoomIn;
    $[37] = zoomOut;
    $[38] = zoomTo;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  return t13;
}